import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Modulo12U3Act6 from "../../../DnD/modulo12U3Act6";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad5.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[5];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[6].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[6].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[4].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[4].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const items = [
    <div className="selectable btn btn-red shadow mx-3 my-1">Machismo</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">Oportunidad</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">Logro</div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul className="">
            <li>Observa las imágenes.</li>
            <li>Arrastra cada palabra a la imagen que corresponda.</li>
          </ul>
        </div>
      </div>

      <Modulo12U3Act6 items={items} />

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa las imágenes. Pídale a los niños
            y niñas que describan oralmente lo que ven en cada una de ellas. Lea
            la segunda indicación: Arrastra cada palabra a la imagen que
            corresponda.. Déles un tiempo a niños y niñas para trabajar
            individualmente. Revise de manera conjunta la actividad. Pregunte
            con qué palabra se puede relacionar cada una de las imágenes y por
            qué.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
